<template>
  <div>
    <ScanUploadForm
      @complete="confirmDialogShown = true"
    />
    <v-dialog
      v-model="confirmDialogShown"
      max-width="40%"
    >
      <v-card>
        <v-card-title class="headline">
          Upload Successful!
        </v-card-title>
        <v-card-text>
          Your images have been successfully uploaded, and are now queued for processing.
          <br>
          What would you like to do now?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click=" $router.go() "
          >
            Upload more images
          </v-btn>
          <v-btn
            color="primary"
            text
            :to="{ name: 'listScans' }"
          >
            Explore sample images
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ScanUploadForm from '@/components/ScanUploadForm.vue';

export default {
  name: 'UploadScanPage',
  components: {
    ScanUploadForm,
  },
  data() {
    return {
      confirmDialogShown: false,
    };
  },
};
</script>
